import { formStyles } from './forms.js';

export const environment = {
  autoSave: false,
  clientId: 'dtr', // Smile client ID
  scope:
    'patient/Patient.read patient/Coverage.read patient/Organization.read patient/Endpoint.read patient/QuestionnaireResponse.read patient/Task.read patient/ServiceRequest.read patient/DeviceRequest.read patient/NutritionOrder.read user/PractitionerRole.read user/Practitioner.read patient/QuestionnaireResponse.write patient/DocumentReference.write patient/Task.write launch online_access openid fhirUser launch/patient launch/practitioner',
  epaProxyBaseUrl: 'https://cms-epa-dtr.smilecdr.com/camel/',
  payerOrgIdentifierSystem: 'http://smiledigitalhealth.com/pa-org-identifier',
  maxUploadSize: '20', // in mb
  standalone: 'crd', // crd or dtr standalone launch
  useHook: 'order-sign', // order-sign is default
  supportedCrdVersions: ['2.1', '2.2'],
  // Provide either inclusion / exclusion list, not both.
  attachmentIncludeTypes: [],
  attachmentExcludeTypes: ['application/octet-stream'],
  logo: './assets/smilelogo.png',
  rendererConfig: {
    enableDefaultStyles: true,
    customStyles: `${formStyles}`,
    showSubmitButton: false,
    displayItemAuthor: true,
    showGroupSeparator: false,
    allowMultipleFiles: true,
    dropDownChoiceAsDefault: true,
    headerMarginTop: 50,
    footerMarginBottom: 70,
  },
};
